import React from "react";
import { Switch, Route } from "react-router-dom";

import { routerPathNames } from "./../../shared/config/routerPathNames";
// import Map from "./../../modules/map/Map";
import Reports from "./../../modules/reports/Reports";
import KeplerGLMap from "../../components/KeplerGLMap";

// import "./Content.scss";

function NotFound() {
  return (
    <div>
      <h1>Not found!</h1>
    </div>
  );
}

const Content = (props) => {
  const mapProps = {
    keplerGl: props.keplerGl,
    geoDistricts: props.data.geoDistricts,
    stores: props.data.stores,
    storeStats: props.data.storeStats,
    districts: props.data.districts,
    districtStats: props.data.districtStats,
    selectedAnalyzeType: props.data.selectedAnalyzeType,
    selectedAttribute: props.data.selectedAttribute,
  };
  return (
    <Switch>
      <Route exact path={routerPathNames.Map}>
        <KeplerGLMap {...mapProps} />
      </Route>
      <Route path={routerPathNames.Reports}>
        <Reports {...props} />
      </Route>
      <Route path={routerPathNames.Default}>
        <KeplerGLMap {...mapProps} />
      </Route>
      <Route>
        <NotFound />
      </Route>
    </Switch>
  );
};

export default Content;
